import React from 'react';
import loadable from '@loadable/component';
import connectRoute from 'app/routes/connectRoute';
import CatalogBibsActions from 'app/actions/CatalogBibsActions';
import ContentAdvisoriesActions from 'app/actions/ContentAdvisoriesActions';

const AllContentNoticesPageContainer = loadable(() =>
  import('app/components/bibs/subpages/AllContentNoticesPage/AllContentNoticesPageContainer')
);

export function AllContentNoticesPageRoute() {
  return <AllContentNoticesPageContainer />;
}

function getRouteData({ dispatch, query, params }) {
  return [
    dispatch(CatalogBibsActions.fetchCatalogBib(params.metadataId)),
    dispatch(ContentAdvisoriesActions.getContentAdvisories({ metadataId: params.metadataId, page: query.page }))
  ];
}

export default connectRoute(AllContentNoticesPageRoute, { getRouteData });
